import { AccountsHttpService } from 'src/app/modules/shared/services/accounts.http.service';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { AccountService } from 'src/app/accounts/accountService';
import { LeadService } from 'src/app/leads/leadService';
import { QuestionnaireFieldsForRules } from './../../constants/lead-account-fields.constants';
import { RouteManagementService } from './../../../../more/route-management/route-management.service';
import { TerriService } from './../../../../more/territory/services/terriService';
import { findInArray } from 'src/app/modules/shared/helpers';
import { FormGroupDirective } from '@angular/forms';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AppMainService } from "../../../../app-main.service";
import { AppMainComponent } from '../../../../app.main.component';
import { AccountGroupId } from "../../models/status";
import { mapToNewArray, mapToNewArrayCities } from './../../helpers';
import { AppRuleSelectionService } from './app.rule.selection.service';
import { FormControlList } from '../../constants/formcontrol-list.constants';
import { StatusGroupIds, TypeGroupIds } from '../../constants/category-groupid.constants';

@Component({
  selector: 'app-rule-selection-modal',
  styleUrls: ['./app.rule.selection.modal.component.scss'],
  templateUrl: './app.rule.selection.modal.component.html',
})
export class AppRuleSelectionModalComponent implements OnChanges {

//  @ViewChild(`ruleForm`) ruleForm: FormGroupDirective;


  displayRuleSelection: boolean = false;
  isDisabled: boolean = false;
  currentRulefilters = [];
  equals = [
    { name: 'Is', code: 'is' },
    { name: 'Is not', code: 'is not' }
  ];
  newCountries = [];
  description;
  appRuleData = {
    description: '',
    ruleLists: []
  }
  filterValues = [];
  selectedModule: any;
  selectedTemplate: any;
  accountSelectedCountry: any = [];
  ruleChoices = [
    { name: 'AND', code: 'and' },
    { name: 'OR', code: 'or' }
  ]

  formSubmited = false;
  formControlList = FormControlList;

  constructor(
    private app: AppMainComponent,
    private leadService: LeadService,
    private accountService: AccountService,
    private ruleService: AppRuleSelectionService,
    private terriService: TerriService,
    private routeService: RouteManagementService,
    public appMainService: AppMainService,
    private accountsHttpService: AccountsHttpService
  ) { }

  @Input() display: boolean = false;
  @Input() title: boolean = false;
  @Input() filters = [];
  @Input() ruleLists = [];
  @Input() note: string = '';
  @Input() selectedAssociatedModule: any;
  @Input() selectedTemplateType: any;
  @Input() countriesList =[];
  @Input() selectedCounrtyIds = [];
  @Input() editModel:boolean = false;

  @Output() cancelClicked = new EventEmitter();
  @Output() onSaveClicked = new EventEmitter();

  currentTitle: string = '';
  currentRuleLists = [];
  currentfilterData = null;
  currentNote: string = '';
  selectedCountries: any = [];
  currentCountriesList = [];
  currentSelectedCountryIds = [];
  isEditModeEnabled = false;

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.display && changes.display.currentValue != undefined) {
      this.displayRuleSelection = changes.display.currentValue;
      this.displaPopup()
    }

    if (changes.title && changes.title.currentValue) {
      this.currentTitle = changes.title.currentValue;
    }
    if (changes.countriesList && changes.countriesList.currentValue) {
      this.currentCountriesList = changes.countriesList.currentValue;
    }
    if (changes.selectedCounrtyIds && changes.selectedCounrtyIds.currentValue) {
      this.currentSelectedCountryIds = changes.selectedCounrtyIds.currentValue;
    }
    if (changes.editModel && changes.editModel.currentValue != undefined) {
      this.isEditModeEnabled = changes.editModel.currentValue;
    }
    if (changes.filters && changes.filters.currentValue) {
      this.currentRulefilters = changes.filters.currentValue;
    }
    if (changes.ruleLists && changes.ruleLists.currentValue) {

        this.currentRuleLists =  ParseHelper.DeepCopy(changes.ruleLists.currentValue);
        let i = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "country");
        if(i > -1){
            this.currentRuleLists[i].filterValue = this.currentRuleLists[i].filterValue[0];
        }
        this.currentRuleLists.map(rule=>{
            if(rule.filter.formControl == FormControlList.DatePicker){
                rule.filterValue = rule.filterValue ? new Date(rule.filterValue) : null;
            }
        })
    }
    if (changes.note && changes.note.currentValue) {
      this.currentNote = changes.note.currentValue;
    }
    if (changes.selectedAssociatedModule && changes.selectedAssociatedModule.currentValue) {
        this.selectedAssociatedModule = changes.selectedAssociatedModule.currentValue;
        this.selectedModule = changes.selectedAssociatedModule.currentValue;
    }
    if (changes.selectedTemplateType && changes.selectedTemplateType.currentValue) {
        this.selectedTemplateType = changes.selectedTemplateType.currentValue;
        this.selectedTemplate = changes.selectedTemplateType.currentValue;
    }
  }

  displaPopup() {

  }

  addQuestionnaireChannelRule() {

    this.currentRuleLists.push({
      "id": 0,
      "filterChoiceId": 0,
      "filterChoice": {
        "code": this.ruleChoices.length > 0 ? "and" : "",
        "name": this.ruleChoices.length > 0 ? "AND" : "",
      },
      "filterId": 0,
      "filter": null,
      "expressionId": 0,
      "expression": {
        "code": "is",
        "name": "Is",
      },
      "filterValueId": 0,
      "filterValue": [],
      "filterOptions": [],
      "formControl": [],
      "isCustomField": false
    });
    //this.getValues(this.currentRuleLists.length - 1, 'add')
  }

  getCurrentRulefilters(i){

    let tempCurrentRulefilters = [...this.currentRulefilters];

    let territoryIndex = this.currentRuleLists.findIndex((rule, index)=> rule?.filter?.field == "territory" && index!=i);

    if(territoryIndex>-1){
        tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> list?.field == "routes");
        return tempCurrentRulefilters;
    }else{
        tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> list?.field !== "routes");

        let trndex = this.currentRuleLists.findIndex((rule, index)=> rule?.filter?.field == "territory" && index==i);

        if(this.currentRuleLists.length>0 && this.currentRuleLists[0].filter && trndex==-1)
            tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> list?.field !== "territory");
    }


    let findCountrySelected = this.currentRuleLists.findIndex((rule, index)=> rule?.filter?.field == "country" && index!=i);
    if(findCountrySelected > -1){
        tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> list?.field !== "country");

        let findStateSelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "state" && index!=i);

        if(findStateSelected > -1){
            tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> list?.field !== "state");

            let findCitySelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "city" && index!=i);
            if(findCitySelected > -1 || i<findStateSelected){
                tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> list?.field !== "city");
            }

        }else{
            tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> (list?.field !== "city"));
            if(i<findCountrySelected)
                tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> (list?.field !== "state"));
        }

    }else{
        tempCurrentRulefilters = tempCurrentRulefilters.filter(list=> (list?.field !== "state" && list?.field !== "city"));
    }

    return tempCurrentRulefilters;
  }

  clearStateCityRule(stateClear=false,cityClear=false){
    let findCountrySelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "country");
    let findStateSelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "state");

    if((findCountrySelected == -1 && findStateSelected>-1) || (stateClear && findStateSelected>-1)){
        this.currentRuleLists[findStateSelected].filterOptions = [];
        this.currentRuleLists[findStateSelected].filterValue = null;
        this.currentRuleLists.splice(findStateSelected,1);
    }

    findStateSelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "state");
    let findCitySelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "city");

    if((findStateSelected == -1 && findCitySelected>-1) || (cityClear && findCitySelected>-1)){
        this.currentRuleLists[findCitySelected].filterOptions = [];
        this.currentRuleLists[findCitySelected].filterValue = null;
        this.currentRuleLists.splice(findCitySelected,1);

        // this.currentRuleLists[findCitySelected].filter = null;
    }
  }

  onChangeValue(rule){
      if(rule.filter?.field == "country"){
        let findStateSelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "state");
        let findCitySelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "city");

        if(findStateSelected>-1){
            this.currentRuleLists[findStateSelected].filterOptions = [];
            this.currentRuleLists[findStateSelected].filterValue = null;

            this.getStatesByCountry(findStateSelected);

            if(findCitySelected>-1){
                this.currentRuleLists[findCitySelected].filterOptions = [];
                this.currentRuleLists[findCitySelected].filterValue = null;
            }
        }

      }else if(rule.filter?.field == "state"){
        let findCitySelected = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "city");

        if(findCitySelected>-1)
          this.getCityByStateList(findCitySelected);
      }else if(rule.filter?.field == "territory"){
        let findSelectedRoutes = this.currentRuleLists.findIndex((rule, index)=> rule.filter?.field == "routes");

        if(findSelectedRoutes>-1){
            this.getRoutesByTerritories(findSelectedRoutes);
        }

      }
  }

  async getValues(i, action) {
    if (action == 'add') {
      this.currentRuleLists[i].filterOptions = [];
      this.currentRuleLists[i].filterValue = null;
      this.currentRuleLists[i].groupChildren = "";
      this.currentRuleLists[i].groupLabel = "";
      this.currentRuleLists[i].group = false;
    }

    switch (this.currentRuleLists[i].filter?.field) {
        case QuestionnaireFieldsForRules.accountTypesName:
            this.getAllAccountTypes(i);
            break;
        case QuestionnaireFieldsForRules.tags:
            this.getAllTags(i);
            break;

        case QuestionnaireFieldsForRules.sourceName:
            this.getAllAccountSource(i);
            break;

        case QuestionnaireFieldsForRules.employeesRangeName:
            this.getAllEmployees(i);
            break;

        case QuestionnaireFieldsForRules.annualRevenueName:
            this.getAllAnnualRevenue(i);
            break;

        case QuestionnaireFieldsForRules.ownershipName:
            this.getAllOwners(i);
            break;

        case QuestionnaireFieldsForRules.classificatioName:
            this.getAllClassification(i);
            break;

        // case QuestionnaireFieldsForRules.timezoneName:
        //     this.getAllTimezones(i);
        //     break;

        case QuestionnaireFieldsForRules.industryName:
            this.getAllIndustries(i);
            break;

        case QuestionnaireFieldsForRules.leadTypesName:
            this.getAllLeadTypes(i);
            break;

        case QuestionnaireFieldsForRules.leadsStatus:
            this.getAllLeadStatus(i);
            break;

        case QuestionnaireFieldsForRules.stageName:
            this.getAllLeadStages(i);
            break;
        case QuestionnaireFieldsForRules.country:
            this.getCountryByTemplateId(i);
            break;
        case QuestionnaireFieldsForRules.state:
            this.getStatesByCountry(i);
            break;

        case QuestionnaireFieldsForRules.city:
            this.getCityByStateList(i);
            break;

        case QuestionnaireFieldsForRules.territory:
            this.getAllTerritoryList(i);
            break;

        case QuestionnaireFieldsForRules.routes:
            this.getRoutesByTerritories(i);
            break;

        default:
            let selecedFilter = this.currentRuleLists[i].filter;
            if (selecedFilter.custom) {
              let typescustom = [];
              const custompickvalues = [];
              typescustom = selecedFilter.pickListValues;
              if (typescustom.length) {
                for (let l of typescustom) {
                  let eachType = {
                    id: l + "",
                    businessName: l,
                  }
                  custompickvalues.push(eachType);
                }
                this.currentRuleLists[i].filterOptions = custompickvalues;
              } else {
                this.currentRuleLists[i].filterOptions = [];
                if (selecedFilter.formControl == FormControlList.Rating) {
                  this.currentRuleLists[i].filterValue = [];
                  this.currentRuleLists[i].filterOptions = [
                    { id: 1, businessName: 1 },
                    { id: 2, businessName: 2 },
                    { id: 3, businessName: 3 },
                    { id: 4, businessName: 4 },
                    { id: 5, businessName: 5 },
                  ];
                } else if (selecedFilter.formControl == FormControlList.DatePicker) {
                  this.currentRuleLists[i].filterValue = '';
                }


              }
            }

            break;
    }

    this.clearStateCityRule();
  }

  getAllTerritoryList(i){
    this.appMainService.isShowSpinner('LoadTerritory')
    this.terriService.ruleTerritoryList(this.selectedModule?.id,this.selectedTemplate?.id).subscribe(types => {
      this.appMainService.isHideSpinner('LoadTerritory')
      types = types?.filter(a=> a?.statusId==1);
      this.currentRuleLists[i].filterOptions = mapToNewArray(types);
    }, err => {
      this.appMainService.isHideSpinner('LoadAccountTypes')
    });
  }

  getRoutesByTerritories(i){

    this.currentRuleLists[i].filterOptions = [];

    let findSelectedTerritories = this.currentRuleLists.find((rule, index)=> rule.filter?.field == "territory");

    if(findSelectedTerritories?.filterValue){
        let terrIds = [];
        for (let ss of findSelectedTerritories?.filterValue) {
            terrIds.push(ss.id);
        }

        if(terrIds.length>0){
          this.appMainService.isShowSpinner('loadRoutes');
          this.routeService.getRoutesByTerritories(terrIds.toString()).subscribe(res => {
            this.appMainService.isHideSpinner('loadRoutes');
                this.currentRuleLists[i].filterOptions = [];
                if(res){
                    this.currentRuleLists[i].filterOptions = mapToNewArray(res);

                    if(this.currentRuleLists[i].filterValue?.length>0){
                        this.currentRuleLists[i].filterValue = findInArray(this.currentRuleLists[i].filterValue, this.currentRuleLists[i].filterOptions);
                    }
                }
          });
        }else{
            this.currentRuleLists[i].filterValue = null;
        }
    }
  }

  getAllAccountTypes(i) {
    this.appMainService.isShowSpinner('LoadAccountTypes')
    this.ruleService.getAllAccountTypes(AccountGroupId.ID).subscribe(types => {
      this.appMainService.isHideSpinner('LoadAccountTypes')
      this.currentRuleLists[i].filterOptions = types?.length>0 ? types.map(obj => ({id: Number(obj.id + ""), businessName: obj?.name})) : [];
    }, err => {
      this.appMainService.isHideSpinner('LoadAccountTypes')
    });
  }

  getAllTags(i) {
    this.accountService.getAllTags().then(tags => {
        let allTags = [];
        if (tags) {
            allTags = tags?.filter(x => x?.statusId == 1);
        }
        this.currentRuleLists[i].filterOptions = mapToNewArray(allTags);
    });
  }

  getAllAccountSource(i) {
    this.appMainService.isShowSpinner('LoadAccountSource');
    this.accountService.getAllSources(this.app.user.organizationId).then(source => {
        this.appMainService.isHideSpinner('LoadAccountSource');
        this.currentRuleLists[i].filterOptions = mapToNewArray(source);
    }, err => {
        this.appMainService.isHideSpinner('LoadAccountSource');
    });
  }

  getAllTimezones(i) {
    this.appMainService.isShowSpinner('LoadTimezones');
    this.accountService.getTimezone().then(timezoneList => {
        this.appMainService.isHideSpinner('LoadTimezones');
        this.currentRuleLists[i].filterOptions = mapToNewArray(timezoneList);
    }, err => {
        this.appMainService.isHideSpinner('LoadTimezones');
    });
  }

  getAllLeadStatus(i) {
    this.appMainService.isShowSpinner('LoadStatus');
    this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(status => {
        this.appMainService.isHideSpinner('LoadStatus');
        this.currentRuleLists[i].filterOptions = mapToNewArray(status);
    }, err => {
        this.appMainService.isHideSpinner('LoadStatus');
    });
  }

  getAllEmployees(i) {
    this.appMainService.isShowSpinner('LoadEmpCount')
    this.ruleService.getAllEmployeesCount().subscribe(counts => {
      this.appMainService.isHideSpinner('LoadEmpCount')
      this.currentRuleLists[i].filterOptions = mapToNewArray(counts);
    }, err => {
      this.appMainService.isHideSpinner('LoadEmpCount')
    });
  }

  getAllAnnualRevenue(i) {
    this.appMainService.isShowSpinner('LoadRevenue')
    this.ruleService.getAllRevenues().subscribe(revenue => {
      this.appMainService.isHideSpinner('LoadRevenue')
      this.currentRuleLists[i].filterOptions = mapToNewArray(revenue);
    }, err => {
      this.appMainService.isHideSpinner('LoadRevenue')
    });
  }
  tree(item) {
    ////console.log(item);
  }
  nodeExpand(event) {
    ////console.log(event);
  }
  unselecttree(item) {
    this.selectedCountries.splice(this.selectedCountries.findIndex(a => a.id === item.node.id), 1)
  }
  selecttree(item) {
    this.selectedCountries.push(item.node)
  }

  // mapDropdownFields(dataSet, mapField='name'){
  //   let allData = []
  //   for (let l of dataSet) {
  //     let eachRevenue = {
  //       id: Number(l.id + ""),
  //       businessName: l[mapField],
  //     }
  //     allData.push(eachRevenue);
  //   }
  //   return allData;
  // }

  getAllOwners(i) {
    this.appMainService.isShowSpinner('LoadOwnerShip')
    this.ruleService.getAllOwnerships().subscribe(owners => {
      this.appMainService.isHideSpinner('LoadOwnerShip')
      this.currentRuleLists[i].filterOptions = mapToNewArray(owners);
    }, err => {
      this.appMainService.isHideSpinner('LoadOwnerShip')

    });
  }

  getAllClassification(i) {
    this.appMainService.isShowSpinner('LoadClassification')

    this.accountsHttpService.getAllStages(this.selectedModule?.id,this.selectedTemplate.id).subscribe(stages => {
      this.appMainService.isHideSpinner('LoadClassification')
      this.currentRuleLists[i].filterOptions = mapToNewArray(stages);
    }, err => {
      this.appMainService.isHideSpinner('LoadClassification')

    });
  }

  getAllIndustries(i) {
    this.appMainService.isHideSpinner('LoadInustries')

    this.ruleService.getAllIndustries().subscribe(industries => {
      this.appMainService.isHideSpinner('LoadInustries')
      this.currentRuleLists[i].filterOptions = mapToNewArray(industries);
    }, err => {
      this.appMainService.isHideSpinner('LoadInustries')

    }
    );
  }

  getCountryByTemplateId(i){
      this.appMainService.isShowSpinner('LoadCountry');
      this.ruleService.getCountryByTemplateId(this.selectedAssociatedModule?.id,this.selectedTemplateType.id).then(res => {
        this.appMainService.isHideSpinner('LoadCountry');
            this.currentRuleLists[i].filterOptions = [];
            if(res)
                this.currentRuleLists[i].filterOptions = mapToNewArray(res);

      });
  }

  getCountryStateCityList(i) {
    this.appMainService.isShowSpinner('LoadCountry')
    let resp = this.currentCountriesList;
      this.appMainService.isHideSpinner('LoadCountry')
      if(this.isEditModeEnabled){
        this.setCountrySelection(i, resp, this.currentSelectedCountryIds )
      } else{
        if (this.selectedModule.name.toLowerCase() == 'account') {
          if (this.selectedTemplateType !== undefined) {
            this.appMainService.isShowSpinner('loadCountry');
            this.ruleService.getCountryByAccount(this.selectedTemplateType.id).then(res => {
              this.appMainService.isHideSpinner('loadCountry');
              this.setCountrySelection(i, resp, res )
            },
            err=>{
              this.appMainService.isHideSpinner('loadCountry');
            })
          }
        }
        if (this.selectedModule.name.toLowerCase() == 'lead') {
          this.appMainService.isShowSpinner('loadCountry');
          this.ruleService.getCountryByLead(this.selectedTemplateType.id).then(res => {
            this.appMainService.isHideSpinner('loadCountry');
            this.setCountrySelection(i, resp, res )
          },
          err=>{
            this.appMainService.isHideSpinner('loadCountry');
          })
        }
      }
  }

  getStatesByCountry(i){

    this.currentRuleLists[i].filterOptions = [];

    let findCountrySelected = this.currentRuleLists.find((rule, index)=> rule.filter?.field == "country");


    if(findCountrySelected?.filterValue?.id){
        this.appMainService.isShowSpinner('loadStates');
        this.ruleService.getStatesByCountry(this.selectedAssociatedModule?.id,this.selectedTemplateType.id,findCountrySelected?.filterValue?.id).then(res => {
          this.appMainService.isHideSpinner('loadStates');
              this.currentRuleLists[i].filterOptions = [];
              if(res)
                  this.currentRuleLists[i].filterOptions = mapToNewArray(res);

        });
    }

  }

  getCityByStateList(i){

    this.currentRuleLists[i].groupChildren = "cities";
    this.currentRuleLists[i].groupLabel = "businessName";
    this.currentRuleLists[i].group = true;

    this.currentRuleLists[i].filterOptions = [];

    let findSelectedStates = this.currentRuleLists.find((rule, index)=> rule.filter?.field == "state");
    let findCountrySelected = this.currentRuleLists.find((rule, index)=> rule.filter?.field == "country");

    if(findSelectedStates?.filterValue){
        let stateIds = [];
        for (let ss of findSelectedStates?.filterValue) {
            stateIds.push(ss.id);
        }

        if(stateIds.length>0){
          this.appMainService.isShowSpinner('loadCities');
          this.ruleService.getCitiesByStates(this.selectedAssociatedModule?.id,this.selectedTemplateType.id,stateIds.toString(),findCountrySelected?.filterValue?.id).then(res => {
            this.appMainService.isHideSpinner('loadCities');
                this.currentRuleLists[i].filterOptions = [];
                if(res){
                    this.currentRuleLists[i].filterOptions = mapToNewArrayCities(res,'stateId','stateName');

                    if(this.currentRuleLists[i].filterValue?.length>0){
                        let cities = this.currentRuleLists[i].filterOptions.reduce((acc, curVal) => {
                            return acc.concat(curVal.cities)
                        }, []);
                        this.currentRuleLists[i].filterValue = findInArray(this.currentRuleLists[i].filterValue, cities);
                    }
                }
          });
        }else{
            this.currentRuleLists[i].filterValue = null;
        }

    }
  }


  setCountrySelection(i, allCountries, selectedIds){
    const selecteAccountCountries = [];
    selectedIds.forEach(ele => {
      let cc = allCountries.find(c => c.id == ele)
      selecteAccountCountries.push(cc)
    })
    this.currentRuleLists[i].filterOptions = [...selecteAccountCountries];
  }

  getAllLeadStages(i) {
    this.appMainService.isShowSpinner('LoadStages')
    this.accountsHttpService.getAllStages(this.selectedModule?.id,this.selectedTemplate.id).subscribe(resp => {
      this.appMainService.isHideSpinner('LoadStages')
      this.currentRuleLists[i].filterOptions = mapToNewArray(resp);
    }, err => {
      this.appMainService.isHideSpinner('LoadStages')
    })
  }


  getAllLeadTypes(i) {
    this.appMainService.isShowSpinner('LoadType')

    this.ruleService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI).subscribe(resp => {
      this.appMainService.isHideSpinner('LoadType')
      this.currentRuleLists[i].filterOptions = mapToNewArray(resp);
    }, err => {
      this.appMainService.isHideSpinner('LoadType')
    })
  }

  QuestionnaireChannelRule() {
    if (!this.isDisabled) {
      this.currentRuleLists.splice(-1, 1);
    }
  }

  onSave() {
    this.formSubmited = true;
    if(!this.ruleListValidation())
        return false;

    this.appRuleData.ruleLists = JSON.parse(JSON.stringify(this.currentRuleLists));

    let i = this.appRuleData.ruleLists.findIndex((rule, index)=> rule.filter?.field == "country");
    if(i > -1){
        this.appRuleData.ruleLists[i].filterValue = [this.appRuleData.ruleLists[i].filterValue];
    }

    this.appRuleData.description = this.currentNote;
    this.displayRuleSelection = false;
    this.onSaveClicked.emit(this.appRuleData)
  }

  ruleListValidation(){
      let validation = true;
      for(let rule of this.currentRuleLists){
        if(!rule.filterValue || rule.filterValue.length<1){
            validation = false;
            break;
        }
      }
      return validation;
  }

  onCancel() {
    this.appRuleData.ruleLists = this.ruleLists;
    this.currentRuleLists = [];
    this.cancelClicked.emit(this.appRuleData)
  }
}
